export default __webpack_public_path__ + "e67d106c78832bd6a0cc289e710bcfc2.svg";